/*
  Customer gallery: fetches every review photo once, tags each one, and filters client-side.
  The tag rules themselves are a theme setting — see parseRules below.
*/
(function () {
  'use strict';

  /*
    Tag rules are edited in the theme editor, not here. One rule per line:

      Tag name: keyword, keyword, keyword

    A photo gets the tag when any keyword appears in its product title or its review text, so
    "Nurse: nurse, hospital" catches both the Nurse Quencher and a review that mentions a hospital.
    Matching is case-insensitive and ignores punctuation. Line order sets the order of the chips.
  */
  function parseRules(text) {
    var rules = [];
    (text || '').split('\n').forEach(function (line) {
      var at = line.indexOf(':');
      if (at < 1) return;
      var name = line.slice(0, at).trim();
      var words = line.slice(at + 1).split(',').map(function (w) { return normalise(w); }).filter(Boolean);
      if (name && words.length) rules.push({ name: name, words: words });
    });
    return rules;
  }

  function normalise(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[’']/g, "'").replace(/\s+/g, ' ').trim();
  }

  function photoId(url) {
    var name = String(url || '').split('?')[0].split('/').pop();
    return name.replace(/^review-etsy-/, '').replace(/\.[a-z]+$/i, '');
  }

  // { "hot pink": "id,id" } -> { id: "hot pink" }
  function invert(grouped) {
    var out = {};
    Object.keys(grouped || {}).forEach(function (name) {
      if (name.charAt(0) === '_' || typeof grouped[name] !== 'string') return;
      grouped[name].split(',').forEach(function (id) {
        id = id.trim();
        if (id) out[id] = name;
      });
    });
    return out;
  }

  // { "Blue": "id,id" } -> { id: ["Blue"] }  (per-photo tags typed in the admin)
  function expandPhotoTags(grouped) {
    var out = {};
    Object.keys(grouped || {}).forEach(function (tag) {
      if (tag.charAt(0) === '_' || typeof grouped[tag] !== 'string') return;
      grouped[tag].split(',').forEach(function (id) {
        id = id.trim();
        if (!id) return;
        (out[id] = out[id] || []).push(tag);
      });
    });
    return out;
  }

  // "Blue: azure, baby blue" -> { "azure": "Blue", "baby blue": "Blue" }
  function parseColourGroups(text) {
    var out = {};
    parseRules(text).forEach(function (rule) {
      rule.words.forEach(function (name) { out[name] = rule.name; });
    });
    return out;
  }

  /*
    Hand-picked photos, written by the tagging tool (?tag=1) and pasted into the Photo tags
    setting. Same one-line-per-tag shape, but the values are photo ids instead of keywords:

      Corporate & logo: 4573269295-1746912844, -3906011298-1705716659

    A leading minus takes the tag off that one photo — that is how a keyword rule gets an
    exception without weakening the rule for every other photo.
  */
  function parseManualTags(text) {
    var out = { add: {}, remove: {} };
    parseRules(text).forEach(function (rule) {
      rule.words.forEach(function (word) {
        var drop = word.charAt(0) === '-';
        var id = drop ? word.slice(1).trim() : word;
        if (!id) return;
        var bag = drop ? out.remove : out.add;
        if (!bag[id]) bag[id] = [];
        if (bag[id].indexOf(rule.name) === -1) bag[id].push(rule.name);
      });
    });
    return out;
  }

  function tagsFor(item, rules) {
    var hay = normalise((item.pt || '') + ' ' + (item.b || ''));
    var out = [];
    for (var i = 0; i < rules.length; i++) {
      for (var j = 0; j < rules[i].words.length; j++) {
        if (hay.indexOf(rules[i].words[j]) !== -1) { out.push(rules[i].name); break; }
      }
    }
    return out;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function sized(url, width) {
    if (!url) return '';
    var base = url.split('?')[0];
    return base + '?width=' + width;
  }

  // Liquid's `json` filter emits a quoted string, so the newlines arrive escaped.
  function settingText(root, selector) {
    var node = root.querySelector(selector);
    var text = node ? node.textContent : '';
    try {
      var decoded = JSON.parse(text);
      if (typeof decoded === 'string') return decoded;
    } catch (e) { /* already plain text */ }
    return text;
  }

  function init(root) {
    if (root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';

    var grid = root.querySelector('[data-gallery-grid]');
    var chipRow = root.querySelector('[data-gallery-filters]');
    var status = root.querySelector('[data-gallery-status]');
    var moreBtn = root.querySelector('[data-gallery-more]');
    var lightbox = root.querySelector('[data-gallery-lightbox]');
    if (!grid) return;

    var perPage = parseInt(root.dataset.perPage, 10) || 24;
    var minPerTag = parseInt(root.dataset.minPerTag, 10) || 8;
    var rules = parseRules(settingText(root, '[data-gallery-rules]'));
    var colourGroups = parseColourGroups(settingText(root, '[data-gallery-colours]'));
    var manualText = settingText(root, '[data-gallery-manual]');
    var manual = parseManualTags(manualText);
    var all = [];
    var view = [];
    var shown = 0;
    var active = null;
    var lastTrigger = null;

    function say(msg) { if (status) status.textContent = msg; }

    function tile(item) {
      var fig = el('figure', 'gallery__tile');
      fig.dataset.photoId = photoId(item.f);
      var btn = el('button', 'gallery__tile-button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Open photo' + (item.a ? ' from ' + item.a : ''));
      var img = new Image();
      img.src = sized(item.f, 400);
      img.srcset = sized(item.f, 300) + ' 300w, ' + sized(item.f, 500) + ' 500w, ' + sized(item.f, 800) + ' 800w';
      img.sizes = '(min-width: 990px) 24vw, (min-width: 750px) 32vw, 48vw';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = item.w || 800;
      img.height = item.h || 800;
      img.alt = item.pt ? 'Customer photo of ' + item.pt : 'Customer photo';
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        if (root.dataset.tagging === 'true') return;
        openLightbox(item, btn);
      });
      fig.appendChild(btn);
      if (item.pt && item.pu) {
        var cap = el('figcaption', 'gallery__caption');
        var a = el('a', 'gallery__product', item.pt);
        a.href = item.pu;
        cap.appendChild(a);
        fig.appendChild(cap);
      }
      return fig;
    }

    function render(reset) {
      if (reset) { grid.innerHTML = ''; shown = 0; }
      var next = view.slice(shown, shown + perPage);
      var frag = document.createDocumentFragment();
      next.forEach(function (item) { frag.appendChild(tile(item)); });
      grid.appendChild(frag);
      shown += next.length;
      if (moreBtn) moreBtn.hidden = shown >= view.length;
      say('Showing ' + shown + ' of ' + view.length + ' photos');
    }

    function applyFilter(tag) {
      active = tag;
      view = tag ? all.filter(function (i) { return i.tags.indexOf(tag) !== -1; }) : all;
      [].forEach.call(chipRow ? chipRow.querySelectorAll('[data-tag]') : [], function (c) {
        var on = (c.dataset.tag || '') === (tag || '');
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.classList.toggle('is-active', on);
      });
      render(true);
    }

    function buildChips() {
      if (!chipRow) return;
      var counts = {};
      all.forEach(function (i) { i.tags.forEach(function (t) { counts[t] = (counts[t] || 0) + 1; }); });
      var tags = rules.map(function (r) { return r.name; }).filter(function (t) { return counts[t] >= minPerTag; });
      Object.keys(counts)
        .filter(function (t) { return tags.indexOf(t) === -1 && counts[t] >= minPerTag; })
        .sort(function (a, b) { return counts[b] - counts[a]; })
        .forEach(function (t) { tags.push(t); });
      chipRow.innerHTML = '';
      var mk = function (label, tag, n) {
        var b = el('button', 'gallery__chip');
        b.type = 'button';
        b.dataset.tag = tag || '';
        // Rebuilding the chips must not drop the highlight off the filter that is still applied.
        var on = (tag || '') === (active || '');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) b.classList.add('is-active');
        b.appendChild(el('span', null, label));
        b.appendChild(el('span', 'gallery__chip-count', String(n)));
        b.addEventListener('click', function () { applyFilter(tag || null); });
        return b;
      };
      chipRow.appendChild(mk('All', null, all.length));
      tags.forEach(function (t) { chipRow.appendChild(mk(t, t, counts[t])); });
    }

    // Keywords and colour give a photo its starting tags; the hand-picked layer goes on top.
    function retag() {
      all.forEach(function (item) {
        var id = photoId(item.f);
        var tags = item.baseTags.slice();
        (manual.add[id] || []).forEach(function (t) { if (tags.indexOf(t) === -1) tags.push(t); });
        var drop = manual.remove[id] || [];
        item.tags = drop.length
          ? tags.filter(function (t) { return drop.indexOf(t) === -1; })
          : tags;
      });
    }

    function openLightbox(item, trigger) {
      if (!lightbox) return;
      lastTrigger = trigger || null;
      var img = lightbox.querySelector('[data-gallery-lightbox-image]');
      var cap = lightbox.querySelector('[data-gallery-lightbox-caption]');
      var link = lightbox.querySelector('[data-gallery-lightbox-link]');
      if (img) { img.src = sized(item.f, 1200); img.alt = item.pt ? 'Customer photo of ' + item.pt : 'Customer photo'; }
      if (cap) cap.textContent = [item.a, item.b].filter(Boolean).join(' — ');
      if (link) {
        if (item.pu) { link.href = item.pu; link.hidden = false; link.textContent = 'Shop ' + (item.pt || 'this product'); }
        else link.hidden = true;
      }
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    }

    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') lightbox.close();
      else lightbox.removeAttribute('open');
      if (lastTrigger) lastTrigger.focus();
    }

    if (lightbox) {
      var closeBtn = lightbox.querySelector('[data-gallery-lightbox-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
      lightbox.addEventListener('cancel', function () { if (lastTrigger) lastTrigger.focus(); });
    }
    if (moreBtn) moreBtn.addEventListener('click', function () { render(false); });

    // The tagging tool is a separate file, loaded only when the URL asks for it, so shoppers
    // never download it.
    var api = {
      root: root,
      grid: grid,
      manual: manual,
      manualText: manualText,
      rules: rules,
      items: function () { return all; },
      photoId: photoId,
      activeFilter: function () { return active; },
      setMinPerTag: function (n) { minPerTag = n; },
      // Separate steps so the tool can recount without wiping the grid the owner is working through.
      retag: retag,
      rebuildChips: buildChips,
      refresh: function () { retag(); buildChips(); applyFilter(active); }
    };

    function maybeLoadTagger() {
      if (!/[?&]tag=1(&|$)/.test(location.search) || !root.dataset.taggerSrc) return;
      if (root.dataset.taggerCss) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = root.dataset.taggerCss;
        document.head.appendChild(link);
      }
      var script = document.createElement('script');
      script.src = root.dataset.taggerSrc;
      script.onload = function () {
        if (typeof window.galleryTagger === 'function') window.galleryTagger(api);
      };
      document.head.appendChild(script);
    }

    var url = root.dataset.feed;
    if (!url) return;
    var photoTags = {};
    var colourwayOf = {};
    say('Loading photos…');
    // No `Accept: application/json` here: Shopify answers that with the page resource as JSON
    // ({"page":{...}}) instead of rendering the ?view=gallery-json template.
    var tagsUrl = root.dataset.photoTags;
    var tagsReady = tagsUrl
      ? fetch(tagsUrl).then(function (r) { return r.ok ? r.json() : {}; }).then(function (j) {
          colourwayOf = invert(j.colourways);
          photoTags = expandPhotoTags(j.tags);
        }).catch(function () {})
      : Promise.resolve();

    tagsReady
      .then(function () { return fetch(url, { headers: { Accept: 'text/html, */*' }, credentials: 'same-origin' }); })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        all = (data.items || []).filter(function (i) { return i && i.f; });
        all.forEach(function (i) {
          var id = photoId(i.f);
          var tags = tagsFor(i, rules);
          var colour = colourGroups[normalise(colourwayOf[id] || '')];
          if (colour && tags.indexOf(colour) === -1) tags.push(colour);
          (photoTags[id] || []).forEach(function (t) { if (tags.indexOf(t) === -1) tags.push(t); });
          i.baseTags = tags;
          i.colourway = colourwayOf[id] || '';
        });
        if (!all.length) { say('No photos yet.'); return; }
        retag();
        buildChips();
        applyFilter(null);
        root.classList.add('gallery--loaded');
        maybeLoadTagger();
      })
      .catch(function () {
        say('Photos could not be loaded right now.');
        root.classList.add('gallery--error');
      });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-gallery]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
